import { ClientError } from '@tribeplatform/gql-client/lib'
import {
  ActionStatus,
  MutationTransferGroupChatOwnershipArgs,
} from '@tribeplatform/gql-client/types'

import {
  UseMutationOptions,
  useMutation,
} from '../../lib/react-query/useMutation.js'
import { useQueryClient } from '../../lib/react-query/useQueryClient.js'
import { useTribeClient } from '../../useTribeClient.js'
import { getChatParticipantsKey } from '../../utils/keys/messaging.key.js'

export const useTransferChatOwnership = (
  options?: UseMutationOptions<
    ActionStatus,
    ClientError,
    MutationTransferGroupChatOwnershipArgs
  >,
) => {
  const { client } = useTribeClient()
  const queryClient = useQueryClient()

  return useMutation<
    ActionStatus,
    ClientError,
    MutationTransferGroupChatOwnershipArgs
  >(
    async (input: MutationTransferGroupChatOwnershipArgs) =>
      client.messaging.transferGroupChatOwnership(input),
    {
      ...(options ?? {}),
      onSuccess: (data, variables, context) => {
        const chatParticipantsKey = getChatParticipantsKey({
          variables: {
            chatId: variables.chatId,
          },
        })

        queryClient.invalidateQueries(chatParticipantsKey)
        options?.onSuccess?.(data, variables, context)
      },
    },
  )
}
